import { ReactiveComponent } from "../../core/ReactiveComponent.core";
import { ICON } from "../Icons/Icons";
import { notificationSettings } from "../engine/data/globalState";

const notificationSettingTemplate = `
<!-- Notifications -->
<div class="settings-modal__content__section" id="notification-settings">
    <div class="settings-modal__content__section-header flex-center-y">
        <h3>Notifications</h3>
        <button class="settings-modal__content__section__close-btn">
            <span class="material-icons-outlined">close</span>
        </button>
    </div>
    <div class="settings-modal__content__section__field">
        <label class="settings-modal__content__switch flex-center-y">
            <div class="flex-center-y">
                ${ICON.PEOPLE_ADD}
                Peer Joined
            </div>
            <input data-bind="peerJoined" type="checkbox" class="settings-modal__content__switch__input">
        </label>
    </div>
    <div class="settings-modal__content__section__field">
        <label class="settings-modal__content__switch flex-center-y">
            <div class="flex-center-y">
                <div style="transform: rotate(180deg); margin-right: 12px; width: 24px; height: 24px;">
                    ${ICON.EXIT}
                </div>
                Peer Leave
            </div>
            <input data-bind="peerLeave" type="checkbox" class="settings-modal__content__switch__input">
        </label>
    </div>
    <div class="settings-modal__content__section__field">
        <label class="settings-modal__content__switch flex-center-y">
            <div class="flex-center-y">
                ${ICON.CHAT}
                New Message
            </div>
            <input data-bind="newMessage" type="checkbox" class="settings-modal__content__switch__input">
        </label>
    </div>
    <!--<div class="settings-modal__content__section__field">
        <label class="settings-modal__content__switch flex-center-y">
            <div class="flex-center-y">
                ${ICON.HAND}
                Hand Raise
            </div>
            <input type="checkbox" class="settings-modal__content__switch__input" checked>
        </label>
    </div>-->
    <div class="settings-modal__content__section__field">
        <label class="settings-modal__content__switch flex-center-y">
            <div class="flex-center-y">
                ${ICON.ERROR}
                Error
            </div>
            <input data-bind="error" type="checkbox" class="settings-modal__content__switch__input">
        </label>
    </div>
</div>
`

export class NotificationSettings extends ReactiveComponent {
    constructor({ model, socket }) {
        const $template = $(notificationSettingTemplate)

        super($template, notificationSettings);

        this.model = model
        this.socket = socket

        this.template = $template

        this.bindStates()
    }

    bindStates() {
        this.bindState('peerJoined', null, (event) => {
            const newVal = $(event.target).is(':checked')
            this.state.peerJoined = newVal;
            localStorage.setItem('notificationSetting_peerJoined', newVal)
        })
        this.bindState('peerLeave', null, (event) => {
            const newVal = $(event.target).is(':checked')
            this.state.peerLeave = newVal;
            localStorage.setItem('notificationSetting_peerLeave', newVal)
        })
        this.bindState('newMessage', null, (event) => {
            const newVal = $(event.target).is(':checked')
            this.state.newMessage = newVal;
            localStorage.setItem('notificationSetting_newMessage', newVal)
        })
        this.bindState('error', null, (event) => {
            const newVal = $(event.target).is(':checked')
            this.state.error = newVal;
            localStorage.setItem('notificationSetting_error', newVal)
        })
    }
}
